module.exports = __webpack_public_path__ + "static/charles-2c0184ed4efe0fa2b33802dd4633c8a2.png";